<template>
    <div>
        <p class="stack-s"><router-link class="text-color" :to="{name: 'customer-details', params: {id: value.id}}">{{value.displayName}}</router-link>
        </p>
        <table class="table table-compact table-definition stack-xs">
            <tr>
                <td>Created</td>
                <td>{{value.createdTime | dateTime}}</td>
            </tr>
            <tr>
                <td>Email</td>
                <td><router-link class="text-color" :to="{name: 'customer-details', params: {id: value.id}}">{{value.email | coverEmpty}}</router-link></td>
            </tr>
            <tr>
                <td class="table-fixed-column-width">Id</td>
                <td><router-link :to="{name: 'customer-details', params: {id: value.id}}">{{value.id}}</router-link></td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: 'search-result-title-customer',
        props: {
            value: {
                type: Object,
                required: true,
            },
        },
    };
</script>
